import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_productos";

const getOrdenesServicioPO = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const createOrdenServicioPO = async (data, usuario) => {
  const response = await axios.post(`${baseUrl}${endpoint}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const updateOrdenServicioPO = async (id, data, usuario) => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteOrdenServicioPO = async (id, usuario) => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

const leerPdfPO = async (file) => {
  const formData = new FormData();
  formData.append("pdf", file);
  const response = await axios.post(
    `${baseUrl}/api/financiero/leer-po-pdf`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

const getEstadosPO = async () => {
  const response = await axios.get(`${baseUrl}/api/financiero/fin_estado`);
  return response.data;
};

const getUnidadesMedidaPO = async () => {
  const response = await axios.get(`${baseUrl}/api/financiero/fin_unidad_medida`);
  return response.data;
};

export {
  getOrdenesServicioPO,
  createOrdenServicioPO,
  updateOrdenServicioPO,
  deleteOrdenServicioPO,
  leerPdfPO,
  getEstadosPO,
  getUnidadesMedidaPO
};
